<template>
  <el-dialog
    :title="lang.payment_method"
    :visible.sync="show"
    :close-on-click-modal="false"
    width="30%"
    :before-close="handleClose"
  >
    <div class="content">
      <ul :class="payType.more ? 'more' : ''">
        <li v-for="(item, index) in payType.list" :key="index" @click="payType.index = index">
          <div class="check-box" :class="{ 'cur': index === payType.index }"></div>
          <img :src="item.paylogo" />
          <span>{{ item.payname }}</span>
        </li>
      </ul>
      <div class="more-btn" @click="payType.more =! payType.more">
        <span>{{ payType.more ? lang.hide_payment_method : lang.more_payment_method }}</span>
        <i v-if="payType.more" class="el-icon-arrow-up" />
        <i v-else class="el-icon-arrow-down" />
      </div>
      <div class="btn" @click="pay">{{ lang.payment }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { getbocpaylist } from '@/api/home'
import { getpayurl } from '@/api/order.js'
export default {
  data() {
    return {
      show: false,
      orderno: '',
      payType: {
        list: [],
        index: 0,
        more: false,
        loading: false
      }
    }
  },
  computed: {
    lang() {
      return this.$t('pay')
    }
  },
  mounted() {
    getbocpaylist({
      platform: this.$platform
    }).then(({ data }) => {
      this.payType.list = data
    })
  },
  methods: {
    showDialog(orderno) {
      this.show = true
      this.orderno = orderno
    },
    async pay() {
      this.payType.loading = true
      const pay = await getpayurl({
        orderno: this.orderno,
        referUrl: '/user/index',
        paytype: this.payType.list[this.payType.index].paytype,
        ordersource: 3
      })
      this.payType.loading = false
      this.$parent.showPayDialog = true
      this.$parent.currentOrder = this.orderno
      this.show = false
      window.open(pay.data.payUrl, '_blank')
      if (pay.code === 1) {
        this.timer = setInterval(() => {
          this.$parent.getPayState(this.orderno)
        }, 5000)
      }
    },
    handleClose() {
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  height: 110px;
  overflow: hidden;
  &.more {
    height: auto;
    overflow: auto;
  }
  li {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    cursor: pointer;
    img {
      width: 24px;
      height: 24px;
      margin: 0 15px;
    }
    span {
      font-size: 14px;
      color: #000;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px;
}
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  &.cur {
    background: #ec9221;
  }
}
.btn {
  text-align: center;
  width: 145px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  background: #ec9221;
  margin: 15px auto 0;
}
.more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #4f4f4f;
  span {
    margin-right: 6px;
  }
}
</style>